import { AbstractControl } from '@angular/forms';
import { startWithFactory } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export const formControlValue = <T>(control: AbstractControl, emitWhileDisabled: boolean = false): Observable<T> =>
  control.valueChanges.pipe(
    startWithFactory(() => control.value),
    filter(() => emitWhileDisabled || !control.disabled)
  );
